import React from 'react';
import { Container, Row, Col, Card, CardTitle, CardText, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css';

const Microsoft = () => {
    return (
        <div className='div-padd'>
            <div className="hero-section">
                <Container>

                    <br />
                    <h1 className="display-4">Microsoft Capabilities</h1>
                    <br></br>
                    <br />
                    <p className="lead"><h4>Brave Fox key capabilities:</h4>
                        <br />
                        <p>Brave Fox offers services across the entire product engineering lifecycle – from architectural assessments to services extensions. A detailed not on our offerings and what our clients leverage us for is listed below:<br />Architectural Assessment<br />Overview:</p>

                        <li>
                            Re architecturing existing applications
                        </li>
                        <li>
                            Platform migration consulting

                        </li>
                        <li>
                            Performance improvement recommendations
                        </li>
                        <br/>
                        <p>Approach:<br />Starting from the customer's leadership vision we help understand the application need in its entirety and provide recommendations that will best suit our customers need.<br /><br/>Value Proposition:</p>
                        <li>Thorough study before recommendation keeping in view, performance, scalability and maintainability in mind</li>

                        <li>More robust performance</li>
                        <li>More features with emerging technologies</li>
                        <li>Lower maintenance cost getting over legacy</li>

                    </p>
                    <br/><br/>
                    <p className="lead"><h4>Software Architecture & Design:</h4>
                        <br />
                        <p>Overview:<br />Architectural Assessment<br />Starting from the customer's product vision, we help prepare a roadmap. The roadmap highlights the specifications, design and development followed by deployment and support plans.<br />We architect and design product for various platforms to effectively cover issues in</p>

                        <li>
                            Scalability
                        </li>
                        <li>
                            Performance
                        </li>
                        <li>
                            Security
                        </li>
                        <li>Usability</li>
                        <li>Maintainability</li>
                        <li>Manageability</li>
                        <li>Supportability</li>
                        <br/>
                        <p>Approach:</p>
                        <li>We allow for flexibility in the development processes, based on our clients’ internal processes.</li>

                        <li>With proven expertise in Agile process, and combined with best practices we bring innovation and process improvement.</li>
                        <br/>
                        <p>Value Proposition:</p>
                        <li>Brave Fox processes and technology used help in realizing clients’ requirements and delivering smarter products in shorter time frames.</li>
                        <li>Keen foresight on user expectations for</li>
                        <li>More functionality</li>
                        <li>Better user experience</li>
                        <li>Better ROI</li>
                        <li>Security and mobility.</li>
                        <br/>
                        <p>Technology Migration</p>
                        <li>VB to VB .net</li>
                        <li>VB to C#</li>
                        <br/>
                        <p>Standard Migration</p>
                        <li>Tool based Migration from VB to VB.NET/C#</li>
                        <li>Maintain functional equivalence to the migrated Code.</li>
                        <li>Certified by Brave Fox testing team for a defect free application</li>
                        <br/>
                        <p>Value Additions</p>
                        <li>Database Migration</li>
                        <li>Functional Use cases</li>
                        <li>Vista Compatibility</li>

                    </p>
                    <br/><br/>
                    <p className="lead"><h4>Application Reengineering:</h4>
                        <br />
                        <p>Overview:<br />

                            In this highly competitive market place, software vendors/clients have to adapt to the changing needs and visualize the future needs to sustain and be successful. By re-engineering, we optimize the software product performance and value to the end-user.<br />

                            Reengineering Services we offer:</p>

                        <li>ASP to ASP.NET</li>
                        <li>Cold Fusion to .NET</li>
                        <li>Java/J2EE to .NET Enterprise Applications</li>
                        <li>ASP or Crystal based reports to SQL Reporting Services</li>
                        <li>.NET 1.0/1.1 based applications to .NET 2.0</li>
                        <li>SQL Server 2000 to SQL Server 2005</li>
                        <br/>
                        <p>Approach:<br />

                            Standard Migration<br />

                            Tool based Migration</p>

                        <li>  Maintain functional equivalence to the migrated Code</li>

                        <li>      Certified by Brave Fox testing team for a defect free application</li>
                        <br/>
                        <p>Premium Migration</p>

                        <li>   Tool based migration from VB to VB .NET / C#</li>

                        <li>  Maintain functional equivalence to the migrated Code</li>

                        <li>   Re-factor the code to make it future proof</li>

                        <li>   Certified by Brave Fox testing team for a defect free application</li>
                        <br/>
                        <p>Value Additions:</p>

                        <li>Database Migration</li>
                        <li>Performance Testing</li>
                        <li>Functional Use cases</li>
                        <br/>
                        <p>Value Proposition:<br />

                            Emerging technologies offer many advantages.<br />

                            Transforming the existing product with no major changes to its inherent functionality<br />

                            Lower Maintenance or same maintenance cost with new and increased features.</p>

                    </p>
                    <br/><br/>
                    <p className="lead"><h4>Software Product Development:</h4>
                        <p>Overview:<br />

                            We offer two types of services</p>

                        <li>New Product Development</li>

                        <li>Product Enhancement</li>
                        <br/>
                        <p>Details of the two are listed herewith:<br />

                            New Product Development:</p>

                        <li>We understand the concern due to lots of fluidity in the initial stages of every new product and new businesses.</li>
                        <li>At Brave Fox we focus on achieving the predictable quality product on schedule.</li>
                        <li>We also provide low-risk engagement in situations where your need is to test the market with quick introduction and an agile process.</li>
                        <li>We bring in value to you with a proof of concept development and testing.</li>
                        <br/>
                        <p>Product Enhancement:<br />

                            To keep pace with the changing market needs and evolving technologies calls for frequent new feature additions to existing products. This puts pressure in resource allocation towards servicing feature requests from existing customers and from their marketing and product management teams. As your trusted engineering partner we help in increasing the product value at reduced costs by</p>

                        <li>Adding new features</li>
                        <li>Improving existing features</li>
                        <li>Adding components to enhance existing products functionality</li>
                        <li>Tuning database performance</li>
                        <li>Tuning application performance</li>
                        <li>Testing the product</li>
                    </p>
                    <br />
                    <br/><br/>
                    <p className="lead"><h4>Non SQL to SQL Migration</h4>

                        <p>Overview:<br />

                            Migration from non SQL to SQL database. With increased cost of licence and maintenance for few obsolete databases, it makes more business sense to migrate to SQL server. Further you get more enhanced product features with SQL server.<br />
                            <br/>
                            Approach:<br />

                            Standard Migration</p>

                        <li>Tool based Migration</li>
                        <li>As is migration : Maintain functional equivalence to the migrated Code</li>
                        <li>Certified by Brave Fox testing team for a defect free application</li><br/>
                        <p>Premium Migration</p>

                        <li>Tool based migration</li>
                        <li>Maintain functional equivalence to the migrated Code</li>
                        <li>Re-factor the code to make it future proof</li>
                        <li>Certified by Brave Fox testing team for a defect free application</li><br/>
                        <p>Value Addition:</p>

                        <li>Application Migration</li>
                        <li>Performance Tuning</li>
                        <li>Functional Use cases</li><br/>
                        <p>Value Proposition:</p>

                        <li>Transforming the existing database with no major changes to its inherent functionality</li>
                        <li>Lower Maintenance or same maintenance cost with new and increased features.</li>

                    </p>
                    <br/><br/>
                    <p className="lead"><h4>Brave Fox Advantage :</h4>
                        <p>Brave Fox focus on Microsoft technology, an experienced management team with key professionals who have been with Microsoft, and well-defined global delivery processes provide customers the advantage they need for cost-effective solution development. Brave Fox has a continuous effort spent on research and analysis effort.</p>
                    </p><br/><br/>
                    <p>Contact us to learn more about how Brave Fox can help you by leveraging Microsoft technologies.<br />
                        <u>info@bravefox.org</u></p><br/>
                    <p />






                </Container>
            </div>




        </div>
    );
}
export default Microsoft;
